import {
  CommonModule,
  ModuleWithData,
  ModuleError,
  PaginationModule,
} from '@/models/store'

import {
  EvCarProfile,
  EvCarProfileStatus,
  EvCarProfileUpdateableKeys,
} from '@/models/evCarProfile'

import {
  getInitialCommonModuleState,
  getInitialDataModuleState,
  getPagintaionModuleState,
} from '@/helpers/store-state'

export type GetEvCarsParams = {
  status?: EvCarProfileStatus
  admin_id?: string
  is_available?: boolean
  external_id?: string
}

export interface EvCarUpdatingModule {
  loadingKeys: EvCarProfileUpdateableKeys[]
  successKeys: EvCarProfileUpdateableKeys[]
  error: null | ModuleError<EvCarProfileUpdateableKeys>
}

export interface EvCarDetailsModule extends ModuleWithData<EvCarProfile> {
  statusUpdating: CommonModule
  updating: EvCarUpdatingModule
}

export interface EvCarTripsModule extends ModuleWithData<any[]> {
  meta?: {
    total: number
    perPage: number
    currentPage: number
    lastPage: number
  }
}

export interface EvCarsState {
  listModule: PaginationModule<EvCarProfile>

  // EvCar details grouped by vehicle id
  evCarsDetails: Record<string, EvCarDetailsModule | undefined>

  // EvCar trips grouped by vehicle id
  evVehicleTrips: Record<string, EvCarTripsModule | undefined>
}

export const getInitialEvCarDetailsState = (): EvCarDetailsModule => ({
  ...getInitialDataModuleState(),
  statusUpdating: getInitialCommonModuleState(),
  updating: { error: null, loadingKeys: [], successKeys: [] },
})

export const getInitialEvCarTripsState = (): EvCarTripsModule => ({
  ...getInitialDataModuleState(),
  meta: undefined,
})

export default (): EvCarsState => ({
  listModule: getPagintaionModuleState(),
  evCarsDetails: {},
  evVehicleTrips: {},
})
